import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

import { StudentDetailPage } from '~features/students/ui/student-detail-page';

const detailsSearchSchema = z.object({
  edit: z.coerce.boolean().optional().catch(undefined),
  /** GHL location id — used when opening from CRM into a top-level tab (ENR-4102). */
  id: z.string().optional(),
});

const Component = () => {
  const { studentId } = Route.useParams();
  const { edit } = Route.useSearch();
  return (
    <StudentDetailPage studentId={studentId} initialEditing={edit === true} />
  );
};

export const Route = createFileRoute('/_auth/_layout/students/$studentId/details')({
  validateSearch: zodValidator(detailsSearchSchema),
  component: Component,
});
